import React from "react";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import Hero from "@/components/home/Hero";
import { CleaningServices, HandymanServices } from "@/components/home/ServicesSections";
import { WhyChooseUs, ProcessSection, AboutSection } from "@/components/home/WhyProcessAbout";
import HappyCustomers from "@/components/home/HappyCustomers";
import BudgetPlanner from "@/components/home/BudgetPlanner";
import QuoteSection from "@/components/home/QuoteSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="home-page">
      <SiteHeader />
      <main>
        <Hero />
        <CleaningServices />
        <HandymanServices />
        <WhyChooseUs />
        <ProcessSection />
        <HappyCustomers />
        <AboutSection />
        <BudgetPlanner />
        <QuoteSection />
      </main>
      <SiteFooter />
    </div>
  );
}
